import adminServices from 'admin/services'
import services from 'services'
import tokenStore from 'services/token-store'
import mappers from 'admin/services/mappers'
import { clearUserDataFromIntercom } from 'chat-bots/intercom'

export default {

  login(login, ldap) {
    const fetchPath = (ldap ? '/v1/admin/session/ldap' : '/session/login')
    if (!login.email || !login.password) {
      return Promise.reject(new Error('Invalid credentials'))
    }
    return services.fetch(fetchPath, { method: 'post', body: { username: login.email, password: login.password } })
      .then(() => this.fetchSession())
      .then((session) => {
        tokenStore.setToken(session.user.csrfToken)
        return session
      })
  },
  samlRedirect(email, redirectPath) {
    return services.fetch('/session/saml-path', { method: 'POST', body: { email, redirectPath} })
  },

  integrationSamlRedirect(authConfigId, redirectPath, token) {
    return services.fetch('/session/integration-saml-path', { method: 'POST', body: { authConfigId, redirectPath, token } })
    
  },

  fetchRegion() {
    return services.fetch('/v1/welcome/region')
  },

  logout(language) {
    clearUserDataFromIntercom(language)
    return adminServices.fetch('/session/logout')
      .then(() => tokenStore.removeToken())
      .catch(adminServices.handleUnauthorized)
  },

  fetchSession() {
    return adminServices.fetch('/v1/admin/session')
      .then((session) => {
        session.user = mappers.mapUserJsonToModel(session.user)
        return session
      })
      .catch(adminServices.handleUnauthorized)
  },

  setLanguage(language) {
    return adminServices.fetch('/v1/admin/session/language', { method: 'post', body: { language } })
      .catch(adminServices.handleUnauthorized)
  },

  joyrideInteraction(page, steps) {
    return adminServices.fetch(
      '/v1/admin/session/joyride',
      {
        method: 'POST',
        body: {
          page,
          steps,
        },
      },
    )
      .catch(adminServices.handleUnauthorized)
  },

  requestDemo(type) {
    return adminServices.fetch(
      '/v1/admin/session/demo',
      {
        method: 'POST',
        body: {
          type,
        },
      },
    )
      .catch(adminServices.handleUnauthorized)
  },
}
